/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolder = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 2v20h20V6h-9.382l-2.001-4zm2 2h5.382l2.001 3.999H20V20H4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFolder as Folder };
